import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import exc_haz_lev from "../img/sswpIcons/Excavation/exc_haz_lev.png";
import exc_per_to_wor from "../img/sswpIcons/Excavation/exc_per_wor.png";
import exc_bac_fil from "../img/sswpIcons/Excavation/exc_bac_fil.png";
import exc_bar from "../img/sswpIcons/Excavation/exc_bar_fen_hoa.png";
import exc_bat_bac from "../img/sswpIcons/Excavation/exc_bat_bac.png";
import exc_cho from "../img/sswpIcons/Excavation/exc_cho.png";
import exc_und from "../img/sswpIcons/Excavation/exc_und.png";
import exc_cov from "../img/sswpIcons/Excavation/exc_cov.png";
import exc_ris_ass from "../img/sswpIcons/Excavation/exc_env_ris_ass.png";
import exc_exa_ins from "../img/sswpIcons/Excavation/exc_exa_ins.png";
import exc_exc_zon from "../img/sswpIcons/Excavation/exc_exc_zon.png";
import exc_lad_acc_egr from "../img/sswpIcons/Excavation/exc_lad_acc.png";
import exc_lig from "../img/sswpIcons/Excavation/exc_lig.png";
import exc_no_und from "../img/sswpIcons/Excavation/exc_no_und.png";
import exc_pro from "../img/sswpIcons/Excavation/exc_pro.png";
import exc_pum from "../img/sswpIcons/Excavation/exc_pum.png";
import exc_saf_sta from "../img/sswpIcons/Excavation/exc_saf_sta.png";
import exc_she_pil from "../img/sswpIcons/Excavation/exc_she_pil.png";
import exc_sho from "../img/sswpIcons/Excavation/exc_sho.png";
import exc_spo_bac from "../img/sswpIcons/Excavation/exc_spo_bac.png";
import exc_tre_box from "../img/sswpIcons/Excavation/exc_tre_box.png";
import exc_fir_gro from "../img/sswpIcons/Excavation/exc_fir_gro.png";
import exc_gro_fra_sec from "../img/sswpIcons/Excavation/exc_gro_fra_sec.png";
import exc_sit_spe_met from "../img/sswpIcons/Excavation/exc_sit_spe_met.png";
const json = {
    icon: exc_haz_lev,
    name: "Excavation",
    text:
        "Excavations and trenches more than 1.25m deep can cause serious accidents in the event of one or both of its sides collapsing. This can result in burial or crushing of workers.",
    icons: {
        exc_exa_ins: {
            name: "Examination & Inspection",
            icon: exc_exa_ins,
            text: (
                <ul>
                    <ListItem text="A person with the necessary mix of training, knowledge and experience must regularly examine the effectiveness of the controls" />
                    <ListItem text="Any defects or inadequacy must be noted and remedial action taken immediately." />
                    <Li>
                        <Typography variant="title">
                            For excavations, inspections must occur
                        </Typography>
                        <ol>
                            <ListItem text="At least once every day during which persons are working" />
                            <ListItem text="If > 2m deep, at the start of each shift" />
                            <ListItem text="After any event likely to have affected the strength or stability of the excavation or shoring" />
                            <ListItem text="After any accidental fall or rock, earth or other material" />
                            <ListItem text="At least once every 7 days where persons are not at work there" />
                            <ListItem text="The inspection should complete an AF3 form." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        exc_fir_gro: {
            name: "Firm Ground",
            icon: exc_fir_gro,
            text: (
                <ul>
                    <ListItem text="This must be assessed by a person with the proper mix of training, knowledge and experience. If the conditions are beyond the competence of the person, then expert advice must be sought." />
                    <ListItem text="The ground on which any plant, scaffold, or other equipment is to be used must be assessed to ensure it is capable of bearing the required load." />
                    <ListItem text="Preparation work on the ground may be required before the task can commence. If this is the case, then this work must be completed prior to the task, and the ground conditions re-assessed." />
                    <ListItem text="Ground must be level." />
                    <ListItem text="Loads cannot be placed closer to excavations edges than the excavation is deep in good ground/weather conditions. In poor ground/weather conditions this distance needs to be increased." />
                </ul>
            )
        },
        exc_env_ris_ass: {
            name: "Environmental Risk Assess",
            icon: exc_ris_ass,
            text: (
                <ul>
                    <ListItem text="This must be carried out in the event of any rainwater, water, or sewerage being removed from an excavation or similar." />
                    <ListItem text="Untreated or contaminated material must not re-enter the ground water." />
                    <ListItem text="If required separate storage of adequate volume must be provided." />
                </ul>
            )
        },
        exc_no_und: {
            name: "No Undermining",
            icon: exc_no_und,
            text: (
                <ul>
                    <ListItem text="Check to ensure that excavation work will not undermine adjacent structures. Use the 1:1 rule as a guide. The excavation should be at least the same distance away from the structure as the excavation is deep. If necessary you will need to underpin or prop the structure before beginning." />
                </ul>
            )
        },
        exc_bac_fil: {
            name: "Back Fill",
            icon: exc_bac_fil,
            text: (
                <ul>
                    <ListItem text="Backfilling should be carried out as soon as work is completed or immediately after support systems are removed." />
                    <Li>
                        <Typography variant="title">
                            It must be done in a safe manner
                        </Typography>
                        <ListItem text="If using plant, use plant safe operating procedures and exclusion zones for operatives on foot." />
                    </Li>
                </ul>
            )
        },
        exc_bat_bac: {
            name: "Batter Back",
            icon: exc_bat_bac,
            text: (
                <ul>
                    <ListItem text="The sides of the trench are sloped back to a safe angle, so that the risk of collapse is eliminated." />
                    <Li>
                        <Typography variant="title">
                            The angle will depend on ground conditions.
                            (measured from horizontal)
                        </Typography>
                        <ol>
                            <ListItem text="Maximum 45 degrees for good ground and dry" />
                            <ListItem text="May be 30 degrees for poor ground but dry" />
                            <ListItem text="May be 10 degrees for wet conditions" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        exc_pro: {
            name: "Propping",
            icon: exc_pro,
            text: (
                <ul>
                    <ListItem text="Propping may be needed even in shallow trenches (<1.25m), particularly if ground conditions are particularly poor or the nature of the work requires workers to lie or crouch in the trench." />
                    <ListItem text="Propping with soldier sets is a simple form of trench support set which can be formed with steel or timber. This system is mostly used in rock, stiff clays and in other soil types with similar self-supporting properties. " />
                    <ListItem text="Unlike shoring, soldier sets retain the earth where there may be a fault in the embankment. Soldier sets only provide ground support at regular intervals and do not provide positive ground support to the whole excavated face. Open soldier sets are only suitable for use in stable soil types." />
                    <Li>
                        <Typography variant="title">
                            The following guidelines should be followed
                        </Typography>
                        <ol>
                            <ListItem text="Keep spoil at least 600mm from edge" />
                            <ListItem text="Soldiers (vertical side element) should protrude at least 500mm above top of trench" />
                            <ListItem text="Top Tom (cross-support) should be no lower than 300mm from trench top" />
                            <ListItem text="Maximum spacing between Toms no more than 750mm" />
                            <ListItem text="All jointing should be secured with nails/screws" />
                            <ListItem text="Maximum spacing between Soldiers 1.5m" />
                            <ListItem text="Minimum size of Soldier 150x38mm" />
                            <ListItem text="Minimum size of Tom 150x38mm" />
                            <ListItem text="Tom needs to be long enough to force Soldier firmly against trench side" />
                            <ListItem text="Space between bottom Tom and trench floor should allow for pipe, generally not more than 1m." />
                        </ol>
                    </Li>
                    <ListItem text="Propping can be adaptable, particularly when working around existing services and can be quick to install especially in shallow excavations." />
                    <ListItem text="It requires considerable experience and skill to install, with each arrangement requiring bespoke design." />
                </ul>
            )
        },
        exc_sho: {
            name: "Shoring",
            icon: exc_sho,
            text: (
                <ul>
                    <ListItem text="Shoring must be installed by competent persons. (It is generally hydraulic type or timber type, and consist of jacks, struts, wailing and sheeting)" />
                    <ListItem text="Shoring may be needed even in shallow trenches (<1.25m), particularly if ground conditions are particularly poor or the nature of the work requires workers to lie or crouch in the trench." />
                    <ListItem text="Shoring work should progress as the excavation work progresses. You should not work ahead of the shoring progress. You can only work inside the protected area of the shoring." />
                    <ListItem text="You must access the shoring area via a ladder, and never climb the shoring structure itself." />
                    <Li>
                        <Typography variant="title">
                            For shoring, inspections must occur
                        </Typography>
                        <ol>
                            <ListItem text="At least once every day during which persons are working" />
                            <ListItem text="If > 2m deep, at the start of each shift" />
                            <ListItem text="After any event likely to have affected the strength or stability of the excavation or shoring" />
                            <ListItem text="After any accidental fall or rock, earth or other material" />
                            <ListItem text="At least once every 7 days where persons are not at work there" />
                        </ol>
                    </Li>
                    <ListItem text="The inspection should complete an AF3 form." />
                    <Li>
                        <Typography variant="title">
                            Shoring inspections should consider
                        </Typography>
                        <ol>
                            <ListItem text="Is the installation as per the design" />
                            <ListItem text="Is the soil and water as per the design" />
                            <ListItem text="Is there ingress of water" />
                            <ListItem text="Are there proper sumps" />
                            <ListItem text="Is material being drawn from behind the sheets" />
                            <ListItem text="What are the deflections in the sheets/frame" />
                            <ListItem text="Hydraulic: pressure hoses and rams to detect abrasion, fatigue or damage such as bent or notched rams." />
                            <ListItem text="Are there tension cracks in the soil. Are there cracks in adjacent structures." />
                            <ListItem text="Is there damage" />
                            <ListItem text="Are there surcharges" />
                            <ListItem text="Are spoil heaps properly controlled" />
                            <ListItem text="Are there proper barriers/ access/ egress." />
                            <ListItem text="Are there gases in the trench" />
                            <ListItem text="Are services marked" />
                            <ListItem text="Are wedges tight" />
                            <ListItem text="Are struts horizontal. Have they hanging chains" />
                            <ListItem text="Is the work happening as per the method statement, and are there any issues evident." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        exc_tre_box: {
            name: "Trench Box",
            icon: exc_tre_box,
            text: (
                <ul>
                    <ListItem text="Trench boxes may be needed even in shallow trenches (<1.25m), particularly if ground conditions are particularly poor or the nature of the work requires workers to lie or crouch in the trench." />
                    <ListItem text="You can only work inside the protected area of the trench box." />
                    <ListItem text="You must access the trench box area via a ladder, and never climb the trench box structure itself." />
                    <ListItem text="These are proprietary systems and the manufacturer’s instructions must be followed. This includes the specified loads, depths and ground conditions. Trench boxes must also be transported and stored in accordance with the manufacturer’s instructions." />
                    <ListItem text="Trench boxes must not be modified." />
                    <ListItem text="Shoring is generally designed to prevent a trench collapse, whereas trench boxes are generally designed to protect workers in the event of a trench collapse. Trench boxes are suitable in open areas where access by an excavator is available. They are generally not suitable where access is difficult or ground conditions prevent the use of plant near the edge." />
                    <ListItem text="They should be capable of being put in place without requiring workers to enter the excavation" />
                    <ListItem text="You must only use the specified lifting points when installing and removing, and follow the manufacturer’s instructions." />
                    <Li>
                        <Typography variant="title">
                            For trench boxes, inspections must occur
                        </Typography>
                        <ol>
                            <ListItem text="At least once every day during which persons are working" />
                            <ListItem text="If > 2m deep, at the start of each shift" />
                            <ListItem text="After any event likely to have affected the strength or stability of the excavation or shoring" />
                            <ListItem text="After any accidental fall or rock, earth or other material" />
                            <ListItem text="At least once every 7 days where persons are not at work there" />
                        </ol>
                    </Li>
                    <ListItem text="The inspection should complete an AF3 form." />
                    <Li>
                        <Typography variant="title">
                            Trench Box inspections should consider
                        </Typography>
                        <ol>
                            <ListItem text="Is the installation as per the design" />
                            <ListItem text="Is the soil and water as per the design" />
                            <ListItem text="Is there ingress of water" />
                            <ListItem text="Are there proper sumps" />
                            <ListItem text="Is material being drawn from behind the sheets" />
                            <ListItem text="What are the deflections in the sheets/frame" />
                            <ListItem text="Hydraulic: pressure hoses and rams to detect abrasion, fatigue or damage such as bent or notched rams." />
                            <ListItem text="Are there tension cracks in the soil. Are there cracks in adjacent structures." />
                            <ListItem text="Is there damage" />
                            <ListItem text="Are there surcharges" />
                            <ListItem text="Are spoil heaps properly controlled" />
                            <ListItem text="Are there proper barriers/ access/ egress." />
                            <ListItem text="Are there gases in the trench" />
                            <ListItem text="Are services marked" />
                            <ListItem text="Are wedges tight" />
                            <ListItem text="Are struts horizontal. Have they hanging chains" />
                        </ol>
                    </Li>
                    <ListItem text="Is the work happening as per the method statement, and are there any issues evident." />
                </ul>
            )
        },
        exc_she_pil: {
            name: "Sheet Piling",
            icon: exc_she_pil,
            text: (
                <ul>
                    <ListItem text="Sheet piling should only be driven by trained and competent operatives." />
                    <ListItem text="There needs to be a thorough examination of services before operations begin." />
                    <ListItem text="Sheet piling is generally installed before excavation work begins." />
                    <ListItem text="Excavations/ Trench stability in the vicinity needs a thorough examination prior to and after piling operations." />
                    <ListItem text="The driving hammers must be inspected before use by a competent person and maintained in good order" />
                    <ListItem text="All workers in the area will require hearing protection and must observe exclusion zones during piling operations." />
                    <ListItem text="Proper controls are required to prevent handling injuries, including lacerations." />
                </ul>
            )
        },
        exc_gro_fra_sec: {
            name: "Ground Frame - Secured",
            icon: exc_gro_fra_sec,
            text: (
                <ul>
                    <ListItem text="Any boards used to allow walking or works over poor ground must be adequately secured. Have regard to the ground conditions, loading requirement and proximity of any excavations." />
                </ul>
            )
        },
        exc_und: {
            name: "Underpinning",
            icon: exc_und,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                        Most types of underpinning involve digging under buildings in confined space. This must be planned by a competent person. To avoid the risk of building collapse, assess the following
                            </Typography>
                        <ol>
                            <ListItem text="Investigate services before digging" />
                            <ListItem text="You must use adequate batter back or shoring" />
                            <ListItem text="Check underpinning pit will not flood or accumulate fumes or gases. Ensure adequate ventilation." />
                            <ListItem text="Strengthen the structure before beginning, including temporary propping etc." />
                            <ListItem text="Check that wall above are strong enough to support themselves over pits" />
                            <ListItem text="Support the sides of the excavation" />
                            <ListItem text="Ensure safe access and ensure that workers have an escape route out of the pit." />
                            <ListItem text="Minimise manual handling by using mechanical aids." />
                            <ListItem text="Use threaded couplers, rather than dowel bars, to connect reinforcement roads between sections of shallow mass concrete" />
                            <ListItem text="Ensure there is adequate supervision during the operation." />
                            <ListItem text="Ensure all workers are wearing the required PPE including hard hats, eye and ear protection, safety boots and gloves" />
                        </ol>
                    </Li>
                </ul>
            )
        },

        exc_bar_fen_hoa: {
            name: "Barriers/ Fencing/ Hoarding",
            icon: exc_bar,
            text: (
                <ul>
                    <ListItem text="Barriers must be used around any unattended openings or excavations." />
                    <ListItem text="Barriers should be used to exclude pedestrians from the works site." />
                    <ListItem text="Barriers should be at least 1.0m high and have a high visibility (red/white bar) rail. The bottom rail should be a maximum of 200mm from ground level. Be careful of hazard created by feet." />
                </ul>
            )
        },
        exc_cov: {
            name: "Covers",
            icon: exc_cov,
            text: (
                <ul>
                    <ListItem text="Any excavation or opening that has not been barriered off must be covered before being left unattended." />
                    <ListItem text="They must be set flush too, and fixed to the surrounding surface. They should have a textured surface to EN 124 (minimum 2mm) or high friction surface to USRV 35, and be strong enough for the potential loading." />
                </ul>
            )
        },
        exc_spo_bac: {
            name: "Spoil Back",
            icon: exc_spo_bac,
            text: (
                <ul>
                    <ListItem text="All materials removed from an excavation should be stored away from the excavation at least the same distance as the excavation is deep. Never place spoil ≤ 600mm from edge." />
                </ul>
            )
        },
        exc_exc_zon: {
            name: "Exclusion Zone",
            icon: exc_exc_zon,
            text: (
                <ul>
                    <ListItem text="Operatives should not work under an area where loads are being lifted or within the working radii of a job." />
                    <ListItem text="Operatives should keep a safe distance from working plant (at least 2 machine lengths at any time)." />
                    <ol>
                        <Typography variant="title">
                            Operatives on foot must clearly know where such
                            zones are and how they are demarked
                        </Typography>
                        <ListItem text="Barriers" />
                        <ListItem text="Markings/ Signage" />
                        <ListItem text="Method of Work" />
                    </ol>
                </ul>
            )
        },
        exc_cho: {
            name: "Chock",
            icon: exc_cho,
            text: (
                <ul>
                    <ListItem text="A chock/ stop block is used to prevent a vehicle approaching too close to the side of an excavation." />
                    <ListItem text="The chock should be fixed and stable and kept clear from debris while may accumulate through use." />
                </ul>
            )
        },

        exc_lad_acc: {
            name: "Ladder Access/Egress",
            icon: exc_lad_acc_egr,
            text: (
                <ul>
                    <ListItem text="All ladder access must be erected by a person with the relevant mix of training, knowledge and experience." />
                    <ListItem text="The ladder must be free from defects" />
                    <ListItem text="The ladder must be of sufficient length to allow the operative to continue to hold it when reaching the required level/floor." />
                    <ListItem text="The ladder must have secure footing and be tied off." />
                    <ListItem text="Any floor gaps at access points must be sufficiently small to prevent operatives having to cross without having a firm hold on the ladder." />
                </ul>
            )
        },
        exc_saf_sta: {
            name: "Safe Stacking",
            icon: exc_saf_sta,
            text: (
                <ul>
                    <ListItem text="Materials should be stored on firm and level ground." />
                    <ListItem text="Check that materials are stable before removing any ties. Ties should only be removed, when the material is ready to be used." />
                    <ListItem text="Pipes should be stacked in a safe manner, with wedges, to prevent falling or rolling." />
                    <ListItem text="Excessive stacking heights must be avoided (operatives should not have to climb onto the stack to load or attach a pipe for lifting)" />
                    <ListItem text="Large sections (e.g. manhole sections) should be stored on their longest/flattest side." />
                </ul>
            )
        },
        exc_pum: {
            name: "Pumping",
            icon: exc_pum,
            text: (
                <ul>
                    <ListItem text="Water build-up in excavations should be pumped out." />
                    <ListItem text="The pump should be well maintained, regularly serviced and have sufficient fuel levels." />
                    <ListItem text="The pump should be secured and located on firm ground, a safe distance from the edge of the excavation, to prevent undermining, and allow operation of the controls." />
                    <ListItem text="The end of the suction hose should have a strainer to prevent blockages entering the system. All hose connections should be clamped." />
                    <ListItem text="The outlet should discharge into an area that will prevent water re-entering the excavation, and the outlet hose should be affixed to the ground to prevent movement." />
                </ul>
            )
        },
        exc_lig: {
            name: "Lighting",
            icon: exc_lig,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Adequate lighting levels and consistency must be
                            provided for operative access and work areas. For
                            guidance, minimum levels;
                        </Typography>
                        <ol>
                            <ListItem text="External circulation areas: 10 lx" />
                            <ListItem text="External Material handling areas: 10 lx" />
                            <ListItem text="Internal circulation areas: 5 lx" />
                            <ListItem text="Internal working areas: 15 lx" />
                            <ListItem text="Concreting: 50 lx" />
                            <ListItem text="Carpentry, joinery, blockwork, plastering: 100 lx" />
                            <ListItem text="Painting, decorating: 200 lx" />
                        </ol>
                        <Typography variant="title">
                            Total lumens = area (m2) x level (lx)/0.23
                            (utilisation)
                        </Typography>
                        <Typography variant="title">
                            Number of lights = total lumens/ lumen output of
                            light
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            If using tower lighting
                        </Typography>
                        <ol>
                            <ListItem text="Ensure ground is stable" />
                            <ListItem text="Ensure no contact with overhead lines" />
                            <ListItem text="Only erect tower lighting during daylight" />
                            <ListItem text="Protect from vehicle impact" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Adequate road lamps must be provided at roadworks
                            during hours of darkness in unlit areas{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Steady state lamps along tapers (every 2nd cone)" />
                            <ListItem text="Steady state lamps or rotating reflectors along longitudinal cone runs (every 2nd cone)" />
                            <ListItem text="Flashing lamps are used only at points of danger" />
                        </ol>
                    </Li>
                </ul>
            )
        },

        exc_per_wor: {
            name: "Permit To Work",
            icon: exc_per_to_wor,
            text: (
                <ul>
                    <ListItem text="This formal system ensures the required controls are in place before beginning a task with a high risk hazard." />
                    <ListItem text="The permit system identifies the controls that must be in place to allow the task to begin. The implementation of these controls must be signed off by an appointed seperate individual, before an operative is permitted to begin the task." />
                    <ListItem text="The permit system should also state the conditions to be met after work is completed and be signed off by the operative (and verified by the appointed individual)." />
                </ul>
            )
        },
        exc_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: exc_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
